import { useMemo } from 'react'
import { useSelector, shallowEqual } from 'react-redux'
import { map, pipe, filter, equals, includes } from 'ramda'

type Options = {
  basePath: string
  names: { [key: string]: string }
  shallow?: boolean
  favorites: Array<string>
  pathname: string
  linkPropsByKey?: { [key: string]: Object }
}

export type Fav = {
  link: string
  title: string
  active: boolean
  props?: Object
}

export default function useFav({
  basePath,
  names,
  shallow,
  favorites,
  pathname,
  linkPropsByKey = {},
}: Options) {
  const favStatuses = useSelector((state: any) => state.settings.fav, shallowEqual)

  const res: Array<Fav> = useMemo(() => {
    return pipe(
      filter((fav: any) => favStatuses[fav]),
      map((fav): Fav => {
        const link = `${basePath}/${fav}`

        return {
          title: names[fav],
          link,
          active: shallow ? includes(link, pathname) : equals(link, pathname),
          ...(linkPropsByKey[fav] ? { props: linkPropsByKey[fav] } : Object.freeze({})),
        }
      }),
    )(favorites)
  }, [basePath, favStatuses, names, pathname, shallow, favorites, linkPropsByKey])

  return res
}
